/**
 * Presets de cor do chip da categoria (fundo + texto).
 *
 * Sao so atalhos do formulario: o backend guarda as duas cores em `#RRGGBB`
 * (SportCategory.background_color / text_color), entao escolher um preset e
 * depois ajustar uma das cores a mao funciona do mesmo jeito. Todos os pares
 * tem contraste de leitura (AA) e aparecem bem sobre a foto do card.
 */
export const CHIP_PRESETS = [
  { id: "male", background: "#DBEAFE", text: "#1E40AF" },
  { id: "female", background: "#FCE7F3", text: "#9D174D" },
  { id: "mixed", background: "#EDE9FE", text: "#5B21B6" },
  { id: "neutral", background: "#F3F4F6", text: "#374151" },
  { id: "youth", background: "#FEF3C7", text: "#92400E" },
  { id: "adult", background: "#DCFCE7", text: "#166534" },
  { id: "master", background: "#FFEDD5", text: "#9A3412" },
  { id: "highlight", background: "#FEE2E2", text: "#991B1B" },
  { id: "maleStrong", background: "#1D4ED8", text: "#FFFFFF" },
  { id: "femaleStrong", background: "#DB2777", text: "#FFFFFF" },
  { id: "dark", background: "#111827", text: "#FFFFFF" },
  { id: "light", background: "#FFFFFF", text: "#111827" },
];

export const DEFAULT_CHIP = CHIP_PRESETS.find((p) => p.id === "neutral");

/** O preset que casa exatamente com as cores (ou undefined = personalizado). */
export const matchPreset = (background, text) =>
  CHIP_PRESETS.find(
    (p) =>
      p.background.toUpperCase() === (background || "").toUpperCase() &&
      p.text.toUpperCase() === (text || "").toUpperCase()
  );
